// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"src-parts-operations-components-PartsOperationsList-PartsOperationsList__container--2FGs2"};